import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["SocialShareButtons"] */ "/vercel/path0/src/components/shared/social-share-buttons.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Breadcrumb","BreadcrumbList","BreadcrumbItem","BreadcrumbLink","BreadcrumbSeparator","BreadcrumbPage"] */ "/vercel/path0/src/components/ui/breadcrumb.tsx");
